import { _baseClient } from '../index';
import { withPagination } from '../pagination';

export const clientList = (pageSize, pageNumber, query = {}) => {
  return withPagination(
    (state) =>
      _baseClient.post('/client/list', {
        body: {
          pageSize: state.pageSize,
          pageNumber: state.pageNumber,
          ...query,
        },
      }),
    { pageSize, pageNumber },
  );
};
export const clientCount = (params) => {
  return _baseClient.post('/client/list', { body: params });
};

export const clientUpdateStatus = (params) => {
  return _baseClient.get('/client/update-status', params);
};
export const clientUpdateStatusId = (params) => {
  return _baseClient.get('/client/update-status-id', params);
};
export const clientNoteCategorySave = (params) => {
  return _baseClient.post('/client/note-category-save', { body: params });
};

export const clientListExport = (params) => {
  return _baseClient.post('/client/export', { body: params }).then((response) => {
    return response;
  });
};
export const clientListExportLikeImport = (params) => {
  return _baseClient.post('/client/export-like-import', { body: params }).then((response) => {
    return response;
  });
};
export const clientTransitionExport = (params) => {
  return _baseClient
    .post('/client/client-transitions-export', { body: params })
    .then((response) => {
      return response;
    });
};

export const clientAdd = (params) => {
  return _baseClient.post('/client/save', { body: params }).then((response) => {
    return response;
  });
};

export const clientGet = (params) => {
  return _baseClient.get('/client/get', params).then((response) => {
    return response;
  });
};

export const clientDelete = (params) => {
  return _baseClient.get('/client/delete', params).then((response) => {
    return response;
  });
};

export const unitClients = (params) => {
  return _baseClient.post('/client/get-unit-clients', { body: params });
};
export const unitTaskClients = (params) => {
  return _baseClient.post('/client/get-task-unit-clients', { body: params });
};

export const clientNotesList = (pageSize, pageNumber, query = {}) => {
  return _baseClient.post('/client/notes-list', {
    body: {
      pageSize: pageSize,
      pageNumber: pageNumber,
      ...query,
    },
  });
};
export const clientNotesUserList = (query = {}) => {
  return _baseClient.post('/client/notes-list-users', {
    body: {
      ...query,
    },
  });
};
export const clientNoteSave = (params) => {
  return _baseClient.post('/client/notes-save', { body: params });
};

export const clientNoteDelete = (params) => {
  return _baseClient.get('/client/notes-delete', params).then((response) => {
    return response;
  });
};
export const clientNoteGet = (params) => {
  return _baseClient.get('/client/notes-get', params).then((response) => {
    return response;
  });
};

export const downloadClientSampleCsv = (params) => {
  return _baseClient.get('/client/download-sample-csv', params);
};

export const downloadClientFundSampleCsv = (params) => {
  return _baseClient.get('/client-fund/download-sample-csv', params);
};
